/**
 * Un producto puede llevar varios tributos (IVA e INC conviven), así que «el impuesto del producto»
 * es una suma de tarifas; la consumen el exporte a Siigo y la tabla del catálogo. Para lo ya
 * vendido manda el desglose congelado de `venta_linea_impuestos`, no esta suma.
 */
export function sumarTarifas(impuestos: { tarifa: number }[]): number {
  return impuestos.reduce((suma, i) => suma + i.tarifa, 0);
}
